import { useEffect } from "react";

const getBoundsZoomLevel = (bounds) => {
    const mapDiv = document.getElementById("google_maps_div");
    const WORLD_DIM = { height: 256, width: 256 };
    const ZOOM_MAX = 17;

    const latRad = (lat) => {
        const sin = Math.sin(lat * Math.PI / 180);
        const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    };

    const zoom = (mapPx, worldPx, fraction) => {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    };

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    if(!ne || !sw) return ZOOM_MAX;
    const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    const lngDiff = ne.lng() - sw.lng();
    const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    const latZoom = zoom(mapDiv.clientHeight, WORLD_DIM.height, latFraction);
    const lngZoom = zoom(mapDiv.clientWidth, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};

const SectorPolygon = ({ childrenCommon, sectorsCommon, sector, editable, isHover, isSecondary, isTarget, nodeId, isImageAligner }) => {

    useEffect(() => {
        const { alternateView, bounds, drawedElements, data, linkIcon,
            closeInfoWindow, openInfoWindow, farmId, gmap } = childrenCommon;
        const { area_sufix, sectorsDict, hidrasDict, sectors, updateSectorArea } = sectorsCommon;

        const sectorData = sectorsDict[sector];

        if (!sectorData) return;

        const pathInfo = data.sectores[sector].path;
        const paths = [];
        for (const point in pathInfo) {
            const LatLng = new window.google.maps.LatLng(pathInfo[point].lat, pathInfo[point].lng);
            bounds.extend(LatLng);
            paths.push(LatLng);
        }

        let isRelated = false;
        if (nodeId) {
            if (Array.isArray(sectorData.sensores)) sectorData.sensores.forEach(sensor => {
                if (sensor.nodoId === nodeId) isRelated = true;
            });

            if (hidrasDict && Array.isArray(sectorData.hidraulicas)) sectorData.hidraulicas.forEach(idHidra => {
                if (hidrasDict[idHidra]?.nodo_id === nodeId) isRelated = true;
            });
        }

        const color = (isSecondary && !isHover) ? (isRelated ? "green" : "gray") : "green";
        const borderColor = "yellow";
        const hoverColor = "darkgreen";

        const polygon = new window.google.maps.Polygon({
            zIndex: isHover ? 3 : (isSecondary ? 1 : 2),
            editable,
            strokeColor: isHover ? borderColor : color,
            strokeWeight: 2,
            fillColor: isImageAligner ? null : isHover ? hoverColor : color,
            fillOpacity: isHover ? 0.8 : 0.5,
            strokePosition: window.google.maps.StrokePosition.INSIDE,
            paths: paths,
            map: gmap
        });
        if (isTarget) {
            drawedElements.current[0] && drawedElements.current[0].setMap(null);
            drawedElements.current[0] = polygon;
            if (updateSectorArea) {
                updateSectorArea(sector, window.google.maps.geometry.spherical.computeArea(paths));
            }
        } else {
            sectors.current[sector] = polygon;
        }

        if (editable) {
            window.google.maps.event.addListener(polygon, "click", (event) => {
                // we do get "t" here to get the updated one
                const innerT = childrenCommon.t;
                closeInfoWindow();
                openInfoWindow(
                    gmap,
                    `<button type="button" class="btn btn-link" id="clickListener">${innerT("maps.delete")}</button>`,
                    event.latLng,
                    () => {
                        polygon.setMap(null);
                        const index = drawedElements.current.indexOf(polygon);
                        if (index > -1) {
                            drawedElements.current.splice(index, 1);
                        }
                        closeInfoWindow();
                    }
                );
            }, { passive: true });
        } else {
            const { nombre, tipo, caudal_teorico, superficie, especie, variedad, cultivos } = sectorData;

            window.google.maps.event.addListener(polygon, "click", (event) => {
                // we do get "t" here to get the updated one
                const { t: innerT, lngs, edit, navigate } = childrenCommon;
                closeInfoWindow();

                const tipoLabel = Array.isArray(tipo) && tipo.map((ts) => ts && innerT(`tipo.sector.${ts}`)).join(", ");
                const supLabel = superficie ? `${tipoLabel || ""} (${innerT("general.number", { value: superficie })} ${area_sufix})` : tipoLabel;
                const caudalLabel = (caudal_teorico !== null && caudal_teorico !== undefined) &&
          `${innerT("farms.zone.caudalTeorico")}: ${innerT("general.number", { value: caudal_teorico })}`;
                const cultivoLabel = especie ?
                    `${especie[lngs[0]] || especie[lngs[1]]}${variedad ? " - " : ""}${variedad ? (variedad[lngs[0]] || variedad[lngs[1]]) : ""}` :
                    (Array.isArray(cultivos) && cultivos.join(", "));

                if (edit) return;
                const content = alternateView ?
                    `<div>${nombre ? `<b>${nombre}</b></br>` : ""
                    }${caudalLabel ? `${caudalLabel}</br>` : ""
                    }${cultivoLabel ? `${cultivoLabel}</br>` : ""
                    }<button type="button" class="btn btn-link m-0 ${isTarget ? "d-none" : "d-block"
                    }" id="clickListener" style="line - height: 1.5em; ">${linkIcon
                    }</button ></div > `
                    :
                    `<div>${nombre ? `<b>${nombre}</b></br>` : ""
                    }${supLabel ? `${supLabel}</br>` : ""
                    }${cultivoLabel ? `${cultivoLabel}</br>` : ""
                    }<button type="button" class="btn btn-link m-0 ${isTarget ? "d-none" : "d-block"
                    }" id="clickListener" style="line - height: 1.5em; ">${linkIcon
                    }</button ></div > `;
                openInfoWindow(
                    gmap,
                    content,
                    event.latLng,
                    () => navigate(
                        { pathname: "/farms/zone", search: `?farm=${farmId}&zone=${sector}` },
                        { state: { expanded:["sectores",`sector-${sector}`], updateTree: true } }
                    )
                );
            }, { passive: true });
        }

        return () => {
            polygon.setMap(null);
            const index = drawedElements.current.indexOf(polygon);
            if (index > -1) {
                drawedElements.current.splice(index, 1);
            }

            if (sectors.current[sector] === polygon) delete sectors.current[sector];
        };
    }, [sector, childrenCommon, sectorsCommon, editable, isHover, isSecondary, isTarget, nodeId]);

    return null;
};

const UnasignedPolygon = ({ childrenCommon, dataPol, isHover }) => {
    useEffect(() => {
        const { alternateView, bounds, drawedElements, data, linkIcon,
            closeInfoWindow, openInfoWindow, farmId, gmap } = childrenCommon;

        const pathInfo = dataPol.path;
        const paths = [];
        for (const point in pathInfo) {
            const LatLng = new window.google.maps.LatLng(pathInfo[point].lat, pathInfo[point].lng);
            bounds.extend(LatLng);
            paths.push(LatLng);
        }

        const color = isHover ? "blue" : "lightblue" ;
        const borderColor = "yellow";
        const hoverColor = "blue";

        const polygon = new window.google.maps.Polygon({
            zIndex: isHover ? 3 : 1,
            editable: false,
            strokeColor: isHover ? borderColor : color,
            strokeWeight: 2,
            fillColor: isHover ? hoverColor : color,
            fillOpacity: isHover ? 0.8 : 0.5,
            strokePosition: window.google.maps.StrokePosition.INSIDE,
            paths: paths,
            map: gmap
        });

        window.google.maps.event.addListener(polygon, "click", (event) => {
            const { t: innerT, lngs, edit, navigate } = childrenCommon;
            closeInfoWindow();
            const content = `<div>${dataPol?.nombre ? `<b>${dataPol?.nombre}</b></br>` : ""}</div > `;

            openInfoWindow(
                gmap,
                content,
                event.latLng
            );
        }, { passive: true });

        return () => {
            polygon.setMap(null);
            const index = drawedElements.current.indexOf(polygon);
            if (index > -1) {
                drawedElements.current.splice(index, 1);
            }
        };

    }, [childrenCommon, dataPol, isHover]);

    return null;
};

const AfterNodesAndSectorsEffect = ({ accountFarms, childrenCommon, sectorsCommon, filterSectors, hideSectors, edit,
    nodesCommon, hideNodes, filterNodes, noTargeted, unasigned }) => {
    useEffect(() => {
        const { updateSectorArea } = sectorsCommon || {};
        const { bounds, drawedElements, data, gmap } = childrenCommon || {};
        if (!data) return;
        if (!noTargeted && filterSectors && !drawedElements.current[0]) {
            filterSectors.forEach((sector) => updateSectorArea(sector, 0));
        }

        let center = data.position;
        if (!center && data.bounds && data.bounds.southWest && data.bounds.northEast) {
            const northEast = new window.google.maps.LatLng(data.bounds.northEast.lat, data.bounds.northEast.lng);
            const southWest = new window.google.maps.LatLng(data.bounds.southWest.lat, data.bounds.southWest.lng);
            center = (new window.google.maps.LatLngBounds(southWest, northEast)).getCenter();
        }
        if (center) bounds.extend(center);

        center = !bounds.isEmpty() && bounds.getCenter();
        const zoomCalculated = getBoundsZoomLevel(bounds);
        setTimeout(() => {
            center && gmap.setCenter(center);
            zoomCalculated && gmap.setZoom(zoomCalculated);
        }, 0);

    // while most of this deps are not used here, we must run the effect every time a node OR sector effect COULD have run
    }, [accountFarms, childrenCommon, sectorsCommon, hideSectors, filterSectors, edit,
    /*childrenCommon,*/ nodesCommon, hideNodes, filterNodes/*, edit*/, noTargeted, unasigned]);

    return null;
};

export { SectorPolygon, UnasignedPolygon, AfterNodesAndSectorsEffect };
